import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import Modal from 'react-modal';
import IosCheckmark from 'react-ionicons/lib/IosCheckmark';

import { get, patch } from '../services/api';
import { getColor } from '../utils';
import colors from '../utils/colors';
import Loading from './Loading/Loading';

const customStyles = {
  content: {
    height: '50%',
    width: '30%',
    padding: 20,
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)'
  }
};

class Order extends Component {

  constructor(props) {
    super(props);
    this.state = {
      order: null,
      statusModal: false,
      teachersModal: false,
      teachers: null
    }
  }

  componentDidMount() {
    this.fetchOrder();
  }

  fetchOrder = async () => {
    const order = await get(`/admin/orders/${this.props.match.params.id}`);
    this.setState({ order });
  }

  closeStatusModal = async (newStatus) => {
    this.setState({ statusModal: false });
    await patch(`/admin/orders/${this.state.order.courseId}`, { status: newStatus });
    this.fetchOrder();
  }

  openTeachersModal = async () => {
    const { order } = this.state;
    let url = '/admin/teachers';
    if (order.subject && order.student && order.student.level) {
      url += `?subjectId=${order.subject.subjectId}&levelId=${order.student.level.levelId}&limit=1000`;
    }
    const teachers = await get(url);
    this.setState({ teachers, teachersModal: true });
  }

  closeTeachersModal = async (newTeacherId) => {
    this.setState({ teachersModal: false, teachers: null });
    await patch(`/admin/orders/${this.state.order.courseId}`, {
      teacherId: newTeacherId,
      status: 'CONFIRMED', // Automatically confirm when assigning a teacher
    });
    this.fetchOrder();
  }

  render() {
    const { order, statusModal, teachersModal, teachers } = this.state;
    if (!order) return <Loading />;

    const statusDisplay = order.status.charAt(0).toUpperCase() + order.status.slice(1).toLowerCase().replace('_', ' ');

    return <div>
      <div style={{ margin: 20 }}>
        <h2>Commande #{order.courseId}</h2>
        <p onClick={() => this.setState({ statusModal: true })} style={{ color: getColor(order.status), cursor: 'pointer' }}>{statusDisplay}</p>
        <p>Date du cours: {new Date(order.startDatetime).toLocaleString()}</p>
        <p>Commandé le: {new Date(order.createdAt).toLocaleString()}</p>
        <p>Matière: {order.subject.name}</p>
        <p>Niveau: {order.student.level ? order.student.level.name : 'N/A'}</p>
        <p>Durée: {order.durationMinutes} minutes</p>
        <p>Type: {order.courseType}</p>
        {order.courseType === 'PHYSICAL' && order.student.user.addresses && order.student.user.addresses.length > 0 && (
          <p>Adresse: {order.student.user.addresses[0].number} {order.student.user.addresses[0].street}, {order.student.user.addresses[0].zipCode} {order.student.user.addresses[0].city}</p>
        )}
        {order.text && <p>Précisions: {order.text}</p>}

        <p>
          Parent: <Link style={{ textDecoration: 'none', color: '#227' }} to={`/pupils/${order.student.user.email}`}>{order.student.user.firstName} {order.student.user.lastName}</Link>
        </p>
        <p>Nom de l'élève: {order.student.name || 'N/A'}</p>

        {order.tutor ? (
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <p>Professeur: <Link style={{ textDecoration: 'none', color: '#227' }} to={`/teachers/${order.tutor.email}`}>{order.tutor.firstName} {order.tutor.lastName}</Link></p>
            <p style={{ color: colors.dark_blue, marginLeft: 5, cursor: 'pointer' }} onClick={this.openTeachersModal}>(Modifier)</p>
            <p style={{ color: colors.error, marginLeft: 10, cursor: 'pointer' }} onClick={() => this.closeTeachersModal(null)}>(Retirer)</p>
          </div>
        ) : (
          <p style={{ color: colors.dark_blue, cursor: 'pointer' }} onClick={this.openTeachersModal}>Sélectionner un professeur</p>
        )}

        {order.tutorReplies && order.tutorReplies.length > 0 && (
          <div style={{ marginTop: 20 }}>
            <h3>Réponses des professeurs</h3>
            <div>
              <h4>Accepté par:</h4>
              {order.tutorReplies.filter(r => r.acceptedOrRefused).map(r => {
                let infos = {};
                if (r.tutor && r.tutor.infos) {
                  if (typeof r.tutor.infos === 'string') {
                    try {
                      infos = JSON.parse(r.tutor.infos);
                    } catch (e) { }
                  } else {
                    infos = r.tutor.infos;
                  }
                }

                return r.tutor ? (
                  <div key={r.tutorId}>
                    <p style={{ color: colors.success }}>
                      <Link to={`/teachers/${r.tutor.email}`}>{r.tutor.firstName} {r.tutor.lastName}</Link> ({r.tutor.email})
                    </p>
                    {(infos.Biographie || infos.bio) && <p style={{ fontSize: 12, color: '#666', marginTop: 0 }}>{infos.Biographie || infos.bio}</p>}
                  </div>
                ) : <p key={r.tutorId} style={{ color: '#ccc' }}>Professeur introuvable ({r.tutorId})</p>
              })}
              {order.tutorReplies.filter(r => r.acceptedOrRefused).length === 0 && <p>Aucun professeur n'a accepté pour le moment.</p>}
            </div>
            <div>
              <h4>Refusé par:</h4>
              {order.tutorReplies.filter(r => !r.acceptedOrRefused).map(r => (
                r.tutor ? (
                  <p key={r.tutorId} style={{ color: colors.error }}>
                    <Link to={`/teachers/${r.tutor.email}`}>{r.tutor.firstName} {r.tutor.lastName}</Link> ({r.tutor.email})
                  </p>
                ) : <p key={r.tutorId} style={{ color: '#ccc' }}>Professeur introuvable ({r.tutorId})</p>
              ))}
              {order.tutorReplies.filter(r => !r.acceptedOrRefused).length === 0 && <p>Aucun professeur n'a refusé pour le moment.</p>}
            </div>
          </div>
        )}
      </div>

      <Modal isOpen={statusModal} onRequestClose={() => this.setState({ statusModal: false })} style={customStyles} ariaHideApp={false}>
        <p style={{ color: colors.error, cursor: 'pointer' }} onClick={() => this.setState({ statusModal: false })}>Annuler</p>
        <h2 style={{ marginLeft: 20 }}>Modifier le statut du cours</h2>
        <div>
          {['ORDERED', 'CONFIRMED', 'COMPLETED', 'PUPIL_CANCELLED', 'TUTOR_CANCELLED'].map(s => (
            <div key={s} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }} onClick={() => this.closeStatusModal(s)}>
              <p style={{ color: getColor(s) }}>{s.charAt(0).toUpperCase() + s.slice(1).toLowerCase().replace('_', ' ')}</p>
              {order.status === s && <IosCheckmark fontSize='30px' color={getColor(order.status)} />}
            </div>
          ))}
        </div>
      </Modal>

      <Modal isOpen={teachersModal} onRequestClose={() => this.setState({ teachersModal: false })} style={customStyles} ariaHideApp={false}>
        <p style={{ color: colors.error, cursor: 'pointer' }} onClick={() => this.setState({ teachersModal: false })}>Annuler</p>
        <h2 style={{ marginLeft: 20 }}>Assigner un professeur</h2>
        <input
          type="text"
          placeholder="Rechercher un professeur..."
          value={this.state.teacherSearch || ''}
          onChange={(e) => this.setState({ teacherSearch: e.target.value })}
          style={{ width: '100%', padding: 10, marginBottom: 10, boxSizing: 'border-box' }}
        />
        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
          {teachers && teachers
            .filter(t => {
              const search = (this.state.teacherSearch || '').toLowerCase();
              const matchName = (t.firstName + ' ' + t.lastName).toLowerCase().includes(search) || t.email.toLowerCase().includes(search);
              // Filter out blocked tutors if the list exists
              const isBlocked = order.student?.user?.blockedTutors?.some(bt => bt.tutorId === t.tutorId);
              return matchName && !isBlocked;
            })
            .map(t => (
              <div key={t.tutorId} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', padding: '5px 0', borderBottom: '1px solid #eee' }} onClick={() => this.closeTeachersModal(t.tutorId)}>
                <p>{t.firstName} {t.lastName} ({t.email})</p>
              </div>
            ))}
          {(!teachers || teachers.length === 0) && <p>Aucun professeur trouvé.</p>}
        </div>
      </Modal>
    </div>
  }
}

export default withRouter(Order);
